<template>
  <v-card flat>
    <v-card-text>
      <h1><i>RSVP</i></h1>
      <h5>by September 15th</h5>
      <v-card flat>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 lg5>
              <location-card />
            </v-flex>
            <v-flex xs12 lg7>
              <br>
              <v-layout align-center justify-center>
                <v-flex md9 xs12 sm8>
                  <v-form>
                    <v-text-field
                      prepend-icon="person"
                      ref="names"
                      name="names"
                      v-model="value.names"
                      :rules="[() => !!value.names || 'This field is required']"
                      label="Guest name(s) first and last"
                      type="text"
                      required
                    />
                    <v-radio-group v-model="value.accepts_rejects">
                      <v-radio label="Accept with pleasure" value="accepts" color="primary" />
                      <v-radio label="Rejects with regret" value="rejects" color="red" />
                    </v-radio-group>
                    <div v-if="value.accepts_rejects=='accepts'">
                      <v-text-field
                        ref="number_of_people"
                        v-model="value.number_of_people"
                        :rules="[() => !!value.number_of_people || 'This field is required']"
                        label="Number of People Attending"
                        required
                        placeholder="1"
                      />
                    </div>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-card-text>
    <v-spacer></v-spacer>
  </v-card>
</template>

<script>
import LocationCard from '@/components/LocationCard.vue';

export default {
  components: {
    LocationCard,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  watch: {
    value() {
      this.$emit('input', this.value);
    },
  },
};
</script>

<style scoped>
h1 {
  text-align: center;
  font: 5rem sans-serif;
}
h2 {
  text-align: center;
  font: 3.5rem sans-serif;
}
h3 {
  text-align: center;
  font: 3rem sans-serif;
}
h4 {
  text-align: center;
  font: 2rem sans-serif;
}
h5 {
  text-align: center;
  font: 1.4rem sans-serif;
}
h6 {
  text-align: center;
  font: 1rem sans-serif;
}
</style>
